export default [
    {
      path: '/admin/reports/shop-compensations',
      name: 'shop-compensate-report',
      meta: { requiresAuth: true },
      component: () => import('@/pages/report/finance/shop-compensate.vue')
    }
  ]
